module.exports = __webpack_public_path__ + "static/media/ic_back.49e99cb8.svg";